export const SELECT_FLIGHT = 'SELECT_FLIGHT';
export const TRAVELER_DETAILS = 'TRAVELER_DETAILS';
export const SEAT_MAP = 'SEAT_MAP';
export const EXTRA_PRODUCTS = 'EXTRA_PRODUCTS';
export const VERIFICATION = 'REVIEW';
export const PAYMENT = 'PAYMENT';
export const ORDER = 'ORDER';
